const electricity_contract = `Hello, I am looking to inquire about an electricity contract.
Could you please provide me with information about the available contract options,
including details on pricing and terms? 
Additionally, I would like to know the procedure for initiating the contract.
Thank you for your assistance`;

export default electricity_contract;